namespace advisorop.components.meetinghub {


    class MultiselectInvestorsController {

        // input param
        investors: domains.IInvestor[] = [];
        selInvestors: domains.IMeetingParticipant[] = [];

        // input output param
        onSelectionChanged: any;

        // helper array... selected rows
        selectedInvestorRows = [];

        // CustomDataStore as a data source for both DataGrid and DropDown
        dsInvestors: any;

        gridDropDownBoxOptions: DevExpress.ui.dxDropDownBoxOptions;
        gridDropDownBox: DevExpress.ui.dxDropDownBox;
        gridOptions: DevExpress.ui.dxDataGridOptions;
        grid: DevExpress.ui.dxDataGrid;

        static $inject = [];
        constructor() {
            this.setupDropDownBox();
        }

        // helper method
        makeAsyncDataSource = () => {
            //console.log("Making Custom Data Source...");
            return new DevExpress.data.CustomStore({
                loadMode: "raw",
                key: "id",
                load: () => {
                    return this.investors;
                }
            });
        };

        setupDropDownBox() {

            this.dsInvestors = this.makeAsyncDataSource();

            this.gridDropDownBoxOptions = {
                bindingOptions: {
                    value: "vm.selectedInvestorRows",
                    activeStateEnabled: "vm.enableDropDownBox()"
                },
                valueExpr: "id",
                displayExpr: "fullName",
                placeholder: "Select investors....",
                onValueChanged: (e) => {
                    this.valueChanged(e);
                },
                contentTemplate: "availableInvestorGrid",
                showClearButton: true,
                dataSource: this.dsInvestors,
                onInitialized: (e) => {
                    this.gridDropDownBox = e.component;
                }
            };

            this.gridOptions = {
                bindingOptions: {
                    "selectedRowKeys": "vm.selectedInvestorRows"
                },
                dataSource: this.dsInvestors,
                paging: { pageSize: 15 },
                columns: [
                    { dataField: "fullName", caption: "Investor" }
                ],
                selection: { mode: "multiple", allowSelectAll: false },
                onSelectionChanged: (selectedItems) => {
                    this.selectionChange(selectedItems);
                },
                onInitialized: (e) => {
                    this.grid = e.component;
                }
            }
        }

        enableDropDownBox(): boolean {
            var enable = false;

            if (this.investors != undefined) {
                enable = this.investors.length > 0;
            }

            return enable;
        }

        valueChanged(e) {
            this.selectedInvestorRows = e.value || [];
        }

        selectionChange(selectedItems) {
            //console.log("Selected Items", selectedItems);
            this.onSelectionChanged({ selectedItems: selectedItems.selectedRowsData });
        }

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
        }

        $onChanges(evt) {
            if (this.gridDropDownBox != undefined) {
                this.gridDropDownBox.getDataSource().reload();
                if (this.grid != undefined) {
                    this.grid.refresh();
                }
            }
            if (this.investors?.length > 0) {
                if (this.selInvestors?.length > 0) {
                    this.selectedInvestorRows = [];
                    this.selInvestors.forEach(i => {
                        if (i.investorId >= 0) {
                            this.selectedInvestorRows.push(i.investorId);
                        }
                    })
                }
            } else {
                this.selectedInvestorRows = [];
            }
        }
    }

    //title 3 types indvidual , joint more than one, custodian 
    class MultiselectInvestors implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.controller = MultiselectInvestorsController;
            this.controllerAs = "vm";
            this.bindings = {
                investors: "<",
                selInvestors: "<",
                onSelectionChanged: "&"
            };
            this.templateUrl = "spa/meeting-hub-module/components/multiselect-investors.html";
        }

    }
    angular.module(Constants.APP).component("multiselectInvestors", new MultiselectInvestors());
}